import React from 'react';
import { default as ReactSelect, createFilter } from 'react-select';
import FileUpload from './FileUpload';

export const Input = ({ label, type, placeholder, required, value, min, max, step, onChange, style, error }) => {
    return (
        <div className="field" style={style || {}}>
            {label &&
            <label className="label">{label}</label>
            }
            <div className="control">
                <input
                    className={`input ${error ? "is-danger" : ""}`}
                    type={type || "text"} placeholder={placeholder || ""}
                    required={required}
                    value={(value !== null && value !== undefined) ? value : ""}
                    onChange={(event) => onChange(event.target.value)}
                    min={min}
                    max={max}
                    step={step}
                />
            </div>
        </div>
    );
}

export const TextArea = ({ label, placeholder, required, rows, value, onChange, style }) => {
    return (
        <div className="field" style={style || {}}>
            {label &&
            <label className="label">{label}</label>
            }
            <div className="control">
                <textarea className="textarea" placeholder={placeholder || ""} required={required} rows={rows} value={value || ""} onChange={(event) => onChange(event.target.value)}/>
            </div>
        </div>
    );
}

// remove diacritics and lower case
const clean = (value) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

// wrap every occurrence of query in label with <mark>, ignoring case and accents
const highlight = (label, query) => {
    const needle = clean((query || "").trim());

    if (!needle) {
        return label;
    }

    // cleaned label, with the index of the original character for each cleaned character
    var haystack = "";
    const indexes = [];

    var offset = 0;

    Array.from(label).forEach((char) => {
        const cleaned = clean(char);

        haystack += cleaned;
        for (let j = 0; j < cleaned.length; j++) {
            indexes.push(offset);
        }

        offset += char.length;
    });

    const parts = [];
    var last = 0;
    var start = haystack.indexOf(needle);

    while (start >= 0) {
        const end = start + needle.length;
        const from = indexes[start];
        const to = end < indexes.length ? indexes[end] : label.length;

        parts.push(label.slice(last, from));
        parts.push(<mark key={from}>{label.slice(from, to)}</mark>);

        last = to;
        start = haystack.indexOf(needle, end);
    }

    parts.push(label.slice(last));

    return <span>{parts}</span>;
}

export const Select = ({ label, placeholder, required, value, options, onChange, style }) => {
    return (
        <div className="field" style={style || {}}>
            {label &&
            <label className="label">{label}</label>
            }
            <div className="control is-expanded">
                <ReactSelect
                    placeholder={placeholder}
                    required={required}
                    value={options && options.find((option) => option.value === value)}
                    options={options}
                    onChange={(event) => onChange((event && event.value) || "")}
                    isClearable
                    isSearchable
                    filterOption={createFilter({
                        matchFrom: 'label',
                        stringify: option => `${option.label}`
                    })}
                    formatOptionLabel={({label}, {context, inputValue}) => context === 'menu' ? highlight(label, inputValue) : label}
                    classNamePrefix="react-select"
                />
                {required &&
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ position: 'absolute', padding: 0, margin: 0, height: 0, opacity: 0 }}
                        value={value}
                        onChange={() => null}
                        required={required}
                    />
                }
            </div>
        </div>
    );
}

export const InputUnit = ({ label, type, placeholder, required, value, onChange, style, error, min, max, step }) => {
    return (
        <div className="field has-addons" style={style || {}}>
            <div className="control is-expanded">
                <input
                    className={`input ${error ? "is-danger" : ""}`}
                    type={type || "text"}
                    placeholder={placeholder || ""}
                    required={required}
                    value={value !== null && value !== undefined ? value : ""}
                    onChange={(event) => onChange(event.target.value)}
                    min={min}
                    max={max}
                    step={step}
                />
            </div>
            <p className="control">
                <a className="button is-static">
                    {label}
                </a>
            </p>
        </div>
    );
}

export const File = ({ label, required, value, onChange }) => {
    return (
        <div className="field">
            {label &&
            <label className="label">{label}</label>
            }
            <div className="control" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <FileUpload accept="image/*" value={value} onChange={(file) => onChange(file)}/>
            </div>
        </div>
    );
}

const Form = ({ submitLabel, cancelLabel, onSubmit, onCancel, children }) => {
    return (
        <form onSubmit={onSubmit}>
            {children}
            <div className="field is-grouped mt-5">
                <div className="control">
                    <button type="submit" className="button is-primary">{submitLabel}</button>
                </div>
                <div className="control">
                    <button type="button" className="button is-light" onClick={onCancel}>{cancelLabel}</button>
                </div>
            </div>
        </form>
    );
}

export default Form;
